function sliceDate(date) {
  const slicedDate = date.slice(0, 10);
  return slicedDate;
}
export default sliceDate;
